export class TypeaheadItemOptions {
    canSincronizarErp: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canSincronizarErp;
    }
}
